module.exports = __webpack_public_path__ + "static/media/01A.2b302899.png";